import * as Phaser from "phaser";
import {isTouchDevice} from "./touch_input";

export const MAP_WIDTH = 20 * 32;    // 640
export const MAP_HEIGHT = 15 * 32;   // 480
export const HUD_HEIGHT = 80;
export const CANVAS_WIDTH = MAP_WIDTH;
// Desktop canvas height (no touch controls)
export const CANVAS_HEIGHT_DESKTOP = MAP_HEIGHT + HUD_HEIGHT; // 560
// Touch canvas height includes the controls zone below the game area
export const CONTROLS_ZONE_HEIGHT = 260;
export const CANVAS_HEIGHT_TOUCH = MAP_HEIGHT + HUD_HEIGHT + CONTROLS_ZONE_HEIGHT; // 820
// Static export kept for backwards compatibility (desktop value)
export const CANVAS_HEIGHT = CANVAS_HEIGHT_DESKTOP;


/** Returns the correct canvas height for the current device at runtime. */
export function getCanvasHeight(): number {
    return isTouchDevice() ? CANVAS_HEIGHT_TOUCH : CANVAS_HEIGHT_DESKTOP;
}

export function generateGameConfig(type, scenes: Phaser.Types.Scenes.SceneType[]) {
    const canvasHeight = getCanvasHeight();
    return {
        type: type,
        width: CANVAS_WIDTH,
        height: canvasHeight,
        pixelArt: true,
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            max: {
                width: CANVAS_WIDTH * 3,    // 1920 — cap upscale at 3x to keep pixel art crisp
                height: canvasHeight * 3,
            },
        },
        physics: {
            default: 'arcade',
        },
        scene: scenes,
        autofocus: undefined
    };
}
